import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";



// services
import { api_GET } from "../../services/api_service.js";
import { showMessage } from "../../services/message.js";

// views
import FichaRequerimentoTransportador from "../../views/Shared/Transportador/FichaRequerimento"
import FichaRequerimentoGerador from "../../views/Shared/Gerador/FichaRequerimento"
import FichaRequerimentoDestino from "../../views/Shared/Destino/FichaRequerimento"

//Context
import { useAuth } from "../../context/auth";

export default function ConsultaRequerimento({ history }) {
    const { setLoading } = useAuth();

    const location = useLocation();
    const [requerimento, set_requerimento] = React.useState(null);

    useEffect(() => {
        if (location.state.requerimento != null) {
            set_requerimento(null);
            setLoading(true);
            getRequerimento(location.state.requerimento.numeroRequerimento, location.state.protocolo.senha);
        }
    }, []);

    const getRequerimento = (numeroRequerimento, senha) => {
        api_GET('requerimento/ByNumeroRequerimentoSenha/' + numeroRequerimento + "/" + senha).then(result => {
            if (result.data.setupSolicitacaoAcao.setupSolicitacao.segmento == "Transportador") {
                api_GET('protocolotransportador/' + result.data.protocolo_Id)
                    .then(result_protocolo => handleOpenRequerimentoTransportador(result_protocolo.data, result.data))
                    .catch(err => showMessage("Aviso", err.message, 'error', null))
                    .finally(() => setLoading(false));
            }
            else if (result.data.setupSolicitacaoAcao.setupSolicitacao.segmento == "Grande Gerador") {
                api_GET('protocologerador/' + result.data.protocolo_Id)
                    .then(result_protocolo => handleOpenRequerimentoGerador(result_protocolo.data, result.data))
                    .catch(err => showMessage("Aviso", err.message, 'error', null))
                    .finally(() => setLoading(false));
            }
            else if (result.data.setupSolicitacaoAcao.setupSolicitacao.segmento == "Destino Final") {
                api_GET('protocolodestino/' + result.data.protocolo_Id)
                    .then(result_protocolo => handleOpenRequerimentoDestino(result_protocolo.data, result.data))
                    .catch(err => showMessage("Aviso", err.message, 'error', null))
                    .finally(() => setLoading(false));
            }
        })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleOpenRequerimentoTransportador = (protocolo, rowData) => {
        if (rowData.status == "Em Andamento" || rowData.status == "Divergente") {
            switch (rowData.setupSolicitacaoAcao.acao) {
                case "Novo Cadastro": {
                    window.location = '/auth/TransportadorRequerimento?protocolo=' + protocolo.numeroProtocolo;
                    break;
                }
                case "Inclusão":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoInclusaoVeiculo',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Exclusão":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoExclusaoVeiculo',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Renovação":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoRenovacao',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Cancelamento":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoCancelamento',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Alteração":
                    history.push({
                        pathname: '/auth/TransportadorRequerimentoAlteracao',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
            }
        }
        else {
            set_requerimento(rowData);
        }
    }

    const handleOpenRequerimentoGerador = (protocolo, rowData) => {
        if (rowData.status == "Em Andamento" || rowData.status == "Divergente") {
            switch (rowData.setupSolicitacaoAcao.acao) {
                case "Novo Cadastro":
                    if (protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RCC" || protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG")
                        window.location = '/auth/GeradorRequerimento?protocolo=' + protocolo.numeroProtocolo;
                    else
                        window.location = '/auth/GeradorRSSRequerimento?protocolo=' + protocolo.numeroProtocolo;
                    break;
                case "Renovação":
                    history.push({
                        pathname: '/auth/GeradorRequerimentoRenovacao',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Cancelamento":
                    history.push({
                        pathname: '/auth/GeradorRequerimentoCancelamento',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Alteração":
                    if (protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RCC" || protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG")
                        history.push({
                            pathname: '/auth/GeradorRequerimentoAlteracao',
                            state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                        });
                    else
                        history.push({
                            pathname: '/auth/GeradorRSSRequerimentoAlteracao',
                            state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                        });
                    break;
            }
        }
        else {
            set_requerimento(rowData);
        }
    }

    const handleOpenRequerimentoDestino = (protocolo, rowData) => {
        if (rowData.status == "Em Andamento" || rowData.status == "Divergente") {
            switch (rowData.setupSolicitacaoAcao.acao) {
                case "Novo Cadastro":
                    window.location = '/auth/DestinoRequerimento?protocolo=' + protocolo.numeroProtocolo;
                    break;
                case "Inclusão":
                    history.push({
                        pathname: '/auth/DestinoRequerimentoInclusaoLocal',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Exclusão":
                    history.push({
                        pathname: '/auth/DestinoRequerimentoExclusaoLocal',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Renovação":
                    history.push({
                        pathname: '/auth/DestinoRequerimentoRenovacao',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
                case "Alteração":
                    history.push({
                        pathname: '/auth/DestinoRequerimentoAlteracao',
                        state: { protocolo: protocolo, setupSolicitacaoAcao: rowData.setupSolicitacaoAcao, requerimento: rowData }
                    });
                    break;
            }
        }
        else {
            set_requerimento(rowData);
        }
    }

    return (
        <>

            {requerimento != null && requerimento.setupSolicitacaoAcao.setupSolicitacao.segmento == "Transportador" &&
                <FichaRequerimentoTransportador
                    item={requerimento}
                    showAcoesGestor={false}
                />
            }
            {requerimento != null && requerimento.setupSolicitacaoAcao.setupSolicitacao.segmento == "Grande Gerador" &&
                <FichaRequerimentoGerador
                    item={requerimento}
                    showAcoesGestor={false}
                />
            }
            {requerimento != null && requerimento.setupSolicitacaoAcao.setupSolicitacao.segmento == "Destino Final" &&
                <FichaRequerimentoDestino
                    item={requerimento}
                    showAcoesGestor={false}
                />
            }

        </>
    );
}